/**
 * Pipeline-domain helpers built on the shared date utilities. Generic
 * formatters (duration / relative / timestamp) now live in `src/utils/date.ts`
 * — keep this file for things that know about pipeline-specific conventions
 * (e.g. parsing "HH:MM UTC" cron-human strings).
 */

export {
  formatDuration,
  formatTimestamp,
  formatTimestampShort,
  formatRelative,
  localTimeZoneAbbrev
} from '../../../utils/date';

// Match "<H>:<MM> UTC" inside schedule strings like "Daily — 00:00 UTC".
const UTC_TIME_RE = /(\d{1,2}):(\d{2})\s*UTC/i;

export const annotateScheduleWithLocal = (schedule: string): string => {
  const match = UTC_TIME_RE.exec(schedule);

  if (!match) {
    return schedule;
  }

  const hour = Number(match[1]);
  const minute = Number(match[2]);

  if (Number.isNaN(hour) || Number.isNaN(minute)) {
    return schedule;
  }

  const utcDate = new Date();

  utcDate.setUTCHours(hour, minute, 0, 0);
  const local = utcDate.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short'
  });

  return `${schedule} (${local})`;
};
